import React, { FunctionComponent } from 'react';
import { Box, Grid } from '@material-ui/core';
import clsx from 'clsx';
import colorButtonStyles from './colorButtonStyles';
import BanIcon from '../../../../stock/components/common/BanIcon';

export interface IColorButtonProps {
  hexColorCode?: string;
  colorImageSource?: string;
  id: string;
  onClick: (id: string) => void;
  isActive: boolean;
  isDisabled?: boolean;
  variant?: 'big' | 'small';
}

const ColorButton: FunctionComponent<IColorButtonProps> = ({
  onClick,
  isActive,
  isDisabled,
  id,
  hexColorCode,
  colorImageSource,
  variant = 'big',
}) => {
  const styles = colorButtonStyles();

  return (
    <Grid item={true} xs={'auto'} key={id} className={styles.container} data-test={`button:color_picker:${id}`}>
      {isDisabled && <BanIcon data-test="button:color_picker:disabled" className={styles.banIcon} />}
      <Box
        aria-disabled={isDisabled}
        onClick={() => onClick(id)}
        className={clsx([
          styles.color,
          { [styles.activeColor]: isActive && !isDisabled },
          { [styles.disabled]: isDisabled },
          { [styles.smallColor]: variant === 'small' },
        ])}
        boxShadow={isActive ? 1 : 0}
        style={{
          background: hexColorCode ? `#${hexColorCode}` : colorImageSource && `url(${colorImageSource}) center`,
        }}
      >
        {isActive && !isDisabled && (
          <Box
            data-test="button:color_picker:active"
            className={clsx([styles.activeColorBorder, { [styles.smallBorder]: variant === 'small' }])}
          />
        )}
      </Box>
    </Grid>
  );
};

export default ColorButton;
